import { Link, useParams } from "@tanstack/react-router";

import { usePageData } from "../lib/api";
import { type DjPageData, djPagePath } from "../lib/publicPages";

/** One DJ, below the station's shared header (see StationLayout). */
const DjPage = () => {
  const { stationSlug, djSlug } = useParams({
    from: "/$stationSlug/djs/$djSlug",
  });
  const state = usePageData<DjPageData>(djPagePath(stationSlug, djSlug));

  if (state.kind === "loading") {
    return <p className="station__quiet mono">Loading…</p>;
  }
  if (state.kind !== "ready") {
    return (
      <div className="station__detail">
        <h2 className="station__detail-name">
          {state.kind === "missing" ? "No such DJ." : "Couldn't load this DJ."}
        </h2>
        <p className="station__blurb">
          {state.kind === "missing"
            ? "Nobody at this address — the link may be mistyped, or they may have moved on."
            : "Try again in a moment."}
        </p>
        <Link className="btn" to="/$stationSlug/djs" params={{ stationSlug }}>
          All DJs
        </Link>
      </div>
    );
  }

  const { dj, shows } = state.data;

  return (
    <div className="station__detail">
      {dj.image_url && (
        <img
          className="station__detail-art station__detail-art--round"
          src={dj.image_url}
          alt=""
        />
      )}

      <h2 className="station__detail-name">{dj.name}</h2>

      {dj.bio && <p className="station__blurb">{dj.bio}</p>}

      {shows.length > 0 && (
        <div className="station__recent">
          <span className="eyebrow">Shows</span>
          <ul className="station__index">
            {shows.map((show) => (
              <li key={show.slug}>
                <Link
                  to="/$stationSlug/shows/$showSlug"
                  params={{ stationSlug, showSlug: show.slug }}
                >
                  <span>{show.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DjPage;
